import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { BLOG_POSTS } from "@/lib/blog";
import { ChapterLabel, Reveal } from "@/components/landing/Reveal";

const BlogIndex = () => {
    useEffect(() => {
        document.title = "The Journal — Thailand Nightlife & VIP Table Guides | BookMyVIP";
        document
            .querySelector('meta[name="description"]')
            ?.setAttribute(
                "content",
                "Guides to VIP table booking in Thailand, Bangkok nightlife areas, bottle service, and planning premium nights in Phuket, Pattaya and Koh Samui."
            );
        return () => {
            document.title = "BookMyVIP | VIP Table Booking in Thailand";
        };
    }, []);

    return (
        <main
            data-testid="blog-index"
            className="mx-auto max-w-7xl px-5 pb-32 pt-32 md:px-10 md:pt-40"
        >
            <Reveal>
                <ChapterLabel number="Nº 10" title="The Journal" testId="blog-label" />
            </Reveal>
            <Reveal delay={0.1}>
                <h1 className="mt-8 max-w-3xl font-serif text-4xl font-medium leading-tight tracking-tight text-ivory md:text-6xl">
                    STORIES FOR{" "}
                    <span className="italic text-gold">BETTER NIGHTS.</span>
                </h1>
            </Reveal>
            <Reveal delay={0.15}>
                <p className="mt-6 max-w-xl text-sm leading-relaxed text-muted md:text-base">
                    Guides to VIP tables, bottle service and Thailand's nightlife
                    cities — written by people who plan these nights for a living.
                </p>
            </Reveal>

            <div className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                {BLOG_POSTS.map((p, i) => (
                    <Reveal key={p.slug} delay={0.03 * (i % 3)} className="h-full">
                        <Link
                            data-testid={`blog-card-${p.slug}`}
                            to={`/blog/${p.slug}`}
                            className="card-zoom group flex h-full flex-col overflow-hidden rounded-sm border border-white/10 bg-[#0F0F0F] transition-colors duration-500 hover:border-gold/40"
                        >
                            <div className="relative h-52 overflow-hidden">
                                <img
                                    src={p.image}
                                    alt={p.title}
                                    loading="lazy"
                                    className="absolute inset-0 h-full w-full object-cover"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#0F0F0F] via-black/30 to-black/10" />
                                <span className="absolute left-5 top-5 border border-gold/40 bg-black/50 px-3 py-1.5 text-[9px] font-bold uppercase tracking-[0.25em] text-gold backdrop-blur-sm">
                                    {p.category}
                                </span>
                            </div>
                            <div className="flex flex-1 flex-col p-7">
                                <h2 className="font-serif text-xl font-medium leading-snug text-ivory transition-colors duration-300 group-hover:text-gold md:text-2xl">
                                    {p.title}
                                </h2>
                                <p className="mt-3 flex-1 text-sm leading-relaxed text-muted">
                                    {p.excerpt}
                                </p>
                                <span className="mt-6 inline-flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.25em] text-ivory/50">
                                    {p.readTime}
                                    <ArrowRight
                                        size={13}
                                        strokeWidth={1.5}
                                        className="text-gold transition-transform duration-300 group-hover:translate-x-1.5"
                                    />
                                </span>
                            </div>
                        </Link>
                    </Reveal>
                ))}
            </div>
        </main>
    );
};

export default BlogIndex;
